<template>
  <div>
    <div class="topNav">
      <el-dropdown @command="switchCurrency" class="currency-switch" trigger="click"
                   @visible-change="tooltipShow=false">

        <el-tooltip :content="$t('Display currencies are for reference only')" placement="left" effect="light"
                    v-model="tooltipShow">
          <span class="el-dropdown-link">
            <i class="el-icon-date"></i>{{ $t(currentCurrency) }}<i class="el-icon-caret-bottom el-icon--right"></i>
          </span>
        </el-tooltip>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            :command="currency"
            v-for="currency of currencies"
            :class="{active:currentCurrency===currency}"
            :key="currency">
            {{ $t(currency) }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown @command="switchLang" class="lang-switch" trigger="click">
      <span class="el-dropdown-link">
        <i class="el-icon-date"></i>{{ langs[currentLang] }}<i class="el-icon-caret-bottom el-icon--right"></i>
      </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="(v,k) of langs"
            :command="k"
            :key="k"
            :class="{active:currentLang===k}"
            :disabled="currentLang===k">
            {{ v }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <div class="mob-switcher" @click="showSwitch=true">
        <span>{{ langs[currentLang] }}</span><span class="mob-currency-switch">/{{ $t(currentCurrency) }}</span> <i
        class="el-icon-caret-bottom"></i>
      </div>
    </div>
    <silk-popup :show="showSwitch" @popup-close="showSwitch=false" class="switch-popup">

      <div class="mob-switch">
        <p>{{ $t('Please choose your language') }}:</p>

        <div class="lang-content">
          <el-button
            v-for="(v,k) of langs"
            :key="k"
            @click="switchLang(k)"
            :class="{active:currentLang===k}">
            {{ v }}
          </el-button>
        </div>

        <p>{{ $t('Please choose your currency') }}:</p>

        <div class="currency-content">
          <el-dropdown @command="switchCurrency" class="currency-switch" trigger="click">
            <span class="el-dropdown-link">
              {{ $t(currentCurrency) }}<i class="el-icon-caret-bottom el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown" class="currency-selecter">
              <el-dropdown-item
                :command="currency"
                v-for="currency of currencies"
                :class="{active:currentCurrency===currency}"
                :key="currency">
                {{ $t(currency) }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

        </div>

        <p class="tips"><i class="el-icon-warning-outline"/>{{ $t('Display currencies are for reference only') }}</p>


      </div>

    </silk-popup>
  </div>

</template>

<script>
import {mapState} from 'vuex'
export default {
  data() {
    return {
      langs: {
        en: 'EN',
        cn: '简',
        tc: '繁',
        // jap: '日本語',
        // ko: '한국어'
      },
      currencies: ['MOP', 'HKD', 'CNY', 'USD', 'JPY', 'KRW'],
      showSwitch: false,
      mobLang: '',
      mobCurrency: '',
      tooltipShow: false
    }
  },
  methods: {
    switchLang(lang) {
      if (lang === this.currentLang) {
        return
      }
      this.$router.replace({name: this.$route.name, query: Object.assign({}, this.$route.query, {lang})})
      document.querySelector('html').setAttribute('lang', this.htmlLang)
      this.showSwitch = false
    },
    switchCurrency(currency) {
      this.$store.commit('stateChange', {k: 'currency', v: currency})
      localStorage.setItem("currency", currency);
      this.$router.replace({
        path: '/refresh',
        query: {
            'skin': this.gaData.skinCode
        }
      })
      this.showSwitch = false
    }
  },
  computed: {
    ...mapState(
      ['gaData']
    ),
    currentLang() {
      return this.$i18n.locale
    },
    htmlLang() {
      const langs = {
        en: 'en-US',
        cn: 'zh-CN',
        tc: 'zh-TW',
        jap: 'ja',
        ko: 'kr'
      }
      return langs[this.currentLang]
    },
    currentCurrency() {
      return this.$store.state.currency || localStorage.currency || this.currencies[0]
    }
  },
  created() {
    this.mobLang = this.currentLang
    this.mobCurrency = this.currentCurrency
    document.querySelector('html').setAttribute('lang', this.htmlLang)
  }
}
</script>
